const normalizeNotificationMeta = (rawMeta) => {
  if (!rawMeta) return {};
  if (typeof rawMeta === "string") {
    try {
      const parsed = JSON.parse(rawMeta);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
      return {};
    }
  }
  return typeof rawMeta === "object" ? rawMeta : {};
};

export const getSinglesNotificationKind = (notification) => {
  const meta = normalizeNotificationMeta(notification?.meta);
  return String(meta.action_kind || meta.actionKind || "").trim().toLowerCase();
};

export const countUnreadSinglesNotifications = (notifications, allowedKinds = []) => {
  const allowed = new Set(
    allowedKinds.map((kind) => String(kind || "").trim().toLowerCase()).filter(Boolean)
  );
  return (Array.isArray(notifications) ? notifications : []).reduce((count, notification) => {
    if (!notification || notification.is_read) return count;
    const kind = getSinglesNotificationKind(notification);
    if (!kind || !allowed.has(kind)) return count;
    return count + 1;
  }, 0);
};

export const getUnreadSinglesNotifications = (notifications, allowedKinds = []) => {
  const allowed = new Set(
    allowedKinds.map((kind) => String(kind || "").trim().toLowerCase()).filter(Boolean)
  );
  return (Array.isArray(notifications) ? notifications : []).filter((notification) => {
    if (!notification || notification.is_read) return false;
    const kind = getSinglesNotificationKind(notification);
    return Boolean(kind && allowed.has(kind));
  });
};

export const formatUnreadBadgeCount = (count) => {
  const numeric = Number(count || 0);
  if (!Number.isFinite(numeric) || numeric <= 0) return null;
  return numeric > 99 ? "99+" : String(numeric);
};
